<div class="annuities-quote-card">
  <section class="annuities-quote-card__content">
    <div class="annuities-quote-card__header">
      <h2 class="annuities-quote-card__heading">Hi, {{ clientName }}</h2>
    </div>
    <div class="annuities-quote-card__body">
      <h3 *ngIf="!isAgentAssisted" class="annuities-quote-card__subheading">
        Your financial professional started your annuity application:
      </h3>
      <div *ngIf="false" class="annuities-quote-card__spinner-container">
        <img class="annuities-quote-card__spinner" src="/img/components/transition-card/loading-spinner-white.gif" />
      </div>
      <div
        class="annuities-quote-card__quote-info annuities-quote-info annuities-quote-info--joint"
        [ngClass]="true ? 'annuities-quote-card__quote-info--active' : ''"
      >
        <div class="annuities-quote-info__column annuities-quote-info--joint__column">
          <div class="annuities-quote-info__details">
            <h4 class="annuities-quote-info__details-heading">Owner</h4>
            <span class="annuities-quote-info__rate annuities-quote-info__rate--active annuities-quote-info__name">
              {{ ownerName }}
            </span>
          </div>
        </div>
        <div class="annuities-quote-info__divider"></div>
        <div class="annuities-quote-info__column annuities-quote-info--joint__column">
          <div class="annuities-quote-info__details">
            <h4 class="annuities-quote-info__details-heading">Annuity</h4>
            <div class="annuities-quote-info__rate annuities-quote-info__rate--active">{{ initialPurchaseAmount }}</div>
          </div>
          <h4 class="annuities-quote-info__details-heading">Product</h4>
          <h4 class="annuities-quote-info__details-heading">{{ product }}</h4>
        </div>
      </div>
    </div>
    <div class="annuities-quote-card__footer">
      <button class="annuities-quote-card__button button button--primary button--yellow" (click)="applyWithQuote()">
        Sign Application
      </button>
    </div>
  </section>
</div>
